import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { DateTimeUtils } from 'src/app/shared/util/date-time.utils';

@Injectable({
  providedIn: 'root'
})
export class PrecastTechWorksheetExcelService {

  async generateWorksheetReport(
    worksheetRecords: any,
    worksheets: any[]
  ): Promise<void> {

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Precast Worksheet');

    // PAGE SETUP
    sheet.pageSetup = {
      orientation: 'landscape',
      paperSize: 9,
      fitToPage: true,
      fitToWidth: 1,
    };

    // COLUMN WIDTHS
    sheet.columns = [
      { width: 10 }, // A
      { width: 12 }, // B
      { width: 10 }, // C
      { width: 12 }, // D
      { width: 12 }, // E
      { width: 10 }, // F
      { width: 10 }, // G
      { width: 10 }, // H
      { width: 11 }, // I
      { width: 10 }, // J
      { width: 10 }, // K
      { width: 10 }, // L
      { width: 10 }, // M
      { width: 10 }, // N
      { width: 10 }, // O
      { width: 10 }, // P
      { width: 10 }, // Q
      { width: 10 }, // R
      { width: 10 }, // S
      { width: 10 }, // T
      { width: 10 }, // U
      { width: 10 }, // V
      { width: 10 }, // W
    ];

    sheet.mergeCells('A1:B1');
    sheet.getCell('A1').value = 'Manager Notes';
    sheet.getCell('A1').font = { bold: true };
    sheet.getCell('A1').alignment = { vertical: 'middle' };

    sheet.mergeCells('C1:R1');
    sheet.getCell('C1').value = '';

    sheet.mergeCells('S1:V1');
    sheet.getCell('S1').value = 'Pre Cast';
    sheet.getCell('S1').font = { bold: true, size: 14 };

    // ROW 2
    //1
    sheet.mergeCells('A2:B2');
    sheet.getCell('A2').value = 'Proj. Reference';
    sheet.getCell('A2').font = { bold: true };
    sheet.mergeCells('C2:F2');
    sheet.getCell('C2').value = worksheetRecords.project.referenceId;

    //2
    sheet.mergeCells('G2:I2');
    sheet.getCell('G2').value = 'Sample Received Date';
    sheet.getCell('G2').font = { bold: true };
    sheet.mergeCells('J2:K2');
    const formattedSampleReceivedDate = DateTimeUtils.getLocalDateTimeFromUTCDate(worksheetRecords.project.sampleReceivedDate, 'MM/dd/yyyy');
    sheet.getCell('J2').value = formattedSampleReceivedDate;

    //3
    sheet.mergeCells('L2:M2');
    sheet.getCell('L2').value = 'Company Name';
    sheet.getCell('L2').font = { bold: true };
    sheet.mergeCells('N2:R2');
    sheet.getCell('N2').value = worksheetRecords.company.name;

    //4
    sheet.mergeCells('S2:T2');
    sheet.getCell('S2').font = { bold: true };
    //5
    sheet.mergeCells('U2:V2');
    sheet.getCell('U2').font = { bold: true };


    // ROW 3
    //1
    sheet.mergeCells('A3:B3');
    sheet.getCell('A3').value = 'Project Name';
    sheet.getCell('A3').font = { bold: true };
    sheet.mergeCells('C3:F3');
    sheet.getCell('C3').value = worksheetRecords.project.projectName;

    //2
    sheet.mergeCells('G3:I3');
    sheet.getCell('G3').value = 'Due Date';
    sheet.getCell('G3').font = { bold: true };
    sheet.mergeCells('J3:K3');
    const formattedDueDate = DateTimeUtils.getLocalDateTimeFromUTCDate(worksheetRecords.project.dueDate,'MM/dd/yyyy');
    sheet.getCell('J3').value = formattedDueDate;

    //3
    sheet.mergeCells('L3:M3');
    sheet.getCell('L3').value = 'Project Location';
    sheet.getCell('L3').font = { bold: true };
    sheet.mergeCells('N3:R3');
    sheet.getCell('N3').value = worksheetRecords.project.projectLocation;

    //4
    sheet.mergeCells('S3:T3');
    //5
    sheet.mergeCells('U3:V3');

    // ROW 4
    //1
    sheet.mergeCells('A4:B4');
    sheet.getCell('A4').value = 'Project Number';
    sheet.getCell('A4').font = { bold: true };
    sheet.mergeCells('C4:F4');
    sheet.getCell('C4').value = worksheetRecords.project.projectNumber;

    //2
    sheet.mergeCells('G4:I4');
    sheet.getCell('G4').value = 'Oven Date';
    sheet.getCell('G4').font = { bold: true };
    sheet.mergeCells('J4:K4');
    sheet.getCell('J4').value = worksheetRecords.project.ovenDate || '';

    //3
    sheet.mergeCells('L4:M4');
    sheet.getCell('L4').value = 'Pre Approval';
    sheet.getCell('L4').font = { bold: true };
    sheet.mergeCells('N4:R4');
    sheet.getCell('N4').value = worksheetRecords.project.preApproval === true ? 'YES' : 'NO';

    //4
    sheet.mergeCells('S4:T4');
    sheet.getCell('S4').value = 'Storage Location';
    sheet.getCell('T4').font = { bold: true };
    //5
    sheet.mergeCells('U4:V4');
    sheet.getCell('U4').value = worksheetRecords.project.storageCompartment || ''

    //ROW5
    //1
    sheet.mergeCells('A5:B5');
    sheet.getCell('A5').value = 'Wet test Data';
    sheet.getCell('A5').font = { bold: true };
    sheet.mergeCells('C5:V5');
    sheet.getCell('C5').value = worksheetRecords.project.wetTestData;

    //ROW6
    //1
    sheet.mergeCells('A6:B6');
    sheet.getCell('A6').value = 'Dry test Data';
    sheet.getCell('A6').font = { bold: true };
    sheet.mergeCells('C6:R6');
    sheet.getCell('C6').value = worksheetRecords.project.dryTestData;
    //4
    sheet.mergeCells('S6:V6');
    sheet.getCell('S6').value = worksheetRecords.project.rushTesting ? 'RUSH' : '',
    sheet.getCell('S6').font = { bold: true, size: 14 };

    //ROW7
    const testingInformation = worksheetRecords.comments
            .filter((x: { projectComment: any }) => x.projectComment?.trim())
            .map((x: { sampleTypeName: any; projectComment: any }) =>
                `${x.sampleTypeName} : ${x.projectComment}`
            )
            .join(' | ');
    sheet.mergeCells('A7:B7');
    sheet.getCell('A7').value = 'Testing Info.';
    sheet.mergeCells('C7:V7');
    sheet.getCell('C7').value = testingInformation;


    // ===== MAIN TABLE HEADER =====
    const startRow = 10;

    // FIRST HEADER ROW
    sheet.mergeCells(`A${startRow}:A${startRow + 1}`);
    sheet.getCell(`A${startRow}`).value = 'In House ID';

    sheet.mergeCells(`B${startRow}:B${startRow + 1}`);
    sheet.getCell(`B${startRow}`).value = 'Sample ID';

    sheet.mergeCells(`C${startRow}:C${startRow + 1}`);
    sheet.getCell(`C${startRow}`).value = 'Cast Date';

    sheet.mergeCells(`D${startRow}:D${startRow + 1}`);
    sheet.getCell(`D${startRow}`).value = 'Sample Type';

    sheet.mergeCells(`E${startRow}:E${startRow + 1}`);
    sheet.getCell(`E${startRow}`).value = 'Mix ID';

    sheet.mergeCells(`F${startRow}:F${startRow + 1}`);
    sheet.getCell(`F${startRow}`).value = 'Tare';

    sheet.mergeCells(`G${startRow}:G${startRow + 1}`);
    sheet.getCell(`G${startRow}`).value = 'Mould Weight';

    sheet.mergeCells(`H${startRow}:H${startRow + 1}`);
    sheet.getCell(`H${startRow}`).value = 'Diameter';

    sheet.mergeCells(`I${startRow}:I${startRow + 1}`);
    sheet.getCell(`I${startRow}`).value = 'Height';

    // TEST 1
    sheet.mergeCells(`J${startRow}:L${startRow}`);
    sheet.getCell(`J${startRow}`).value = 'Test 1';

    sheet.getCell(`J${startRow + 1}`).value = 'Weight';
    sheet.getCell(`K${startRow + 1}`).value = 'TR';
    sheet.getCell(`L${startRow + 1}`).value = 'M/C';

    // TEST 2
    sheet.mergeCells(`M${startRow}:O${startRow}`);
    sheet.getCell(`M${startRow}`).value = 'Test 2';

    sheet.getCell(`M${startRow + 1}`).value = 'Weight';
    sheet.getCell(`N${startRow + 1}`).value = 'TR';
    sheet.getCell(`O${startRow + 1}`).value = 'M/C';

    // TEST 3
    sheet.mergeCells(`P${startRow}:R${startRow}`);
    sheet.getCell(`P${startRow}`).value = 'Test 3';

    sheet.getCell(`P${startRow + 1}`).value = 'Weight';
    sheet.getCell(`Q${startRow + 1}`).value = 'TR';
    sheet.getCell(`R${startRow + 1}`).value = 'M/C';

    // DRY TEST
    sheet.mergeCells(`S${startRow}:T${startRow}`);
    sheet.getCell(`S${startRow}`).value = 'Dry Test';

    sheet.getCell(`S${startRow + 1}`).value = 'Dry Weight';
    sheet.getCell(`T${startRow + 1}`).value = 'Dry TR';

    // DENSITY
    sheet.mergeCells(`U${startRow}:U${startRow + 1}`);
    sheet.getCell(`U${startRow}`).value = 'Density';

    // NOTE
    sheet.mergeCells(`V${startRow}:V${startRow + 1}`);
    sheet.getCell(`V${startRow}`).value = 'Note';

    // STYLE HEADERS
    [startRow, startRow + 1].forEach(r => {
      sheet.getRow(r).eachCell(cell => {

        cell.font = {
          bold: true
        };

        cell.alignment = {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true
        };

        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'D9D9D9' }
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });

    // ===== DATA ROWS =====

    let currentRow = startRow + 2;
    for (let i = 0; i < worksheets.length; i++) {
      const item = worksheets[i];
      const current = worksheets[i];
      const next = worksheets[i + 1];
      const isLastRowOfSample = !next || next.sampleId !== current.sampleId;
      const row = sheet.getRow(currentRow);
      const formattedCastDate = DateTimeUtils.formatDateAndTime(item.castDate, 'MM/dd/yy');

      const tests = (item.preCastWorkSheetTestResults ?? [])
                    .sort((a: any, b: any) => a.testNumber - b.testNumber);
      // last test ALWAYS goes to Test3
      const testDryTest = tests.length > 0 ? tests[tests.length - 1] : null;
      // middle tests only exist if we have enough items
      const test1 = tests[0] ?? null;
      const test2 = tests.length  > 2 ? tests[1] : null;
      const test3 = tests.length > 3 ? tests[2] : null;

      const totalTare = Number(item.tare ?? 0) + Number(item.mould ?? 0);
      const dryWeight = Number(testDryTest?.weight?? 0) - totalTare;
      // MC calculations
      const moisture1 = this.calculateMC(test1?.weight, dryWeight, totalTare) ?? '';
      const moisture2 = tests.length > 2 ? this.calculateMC(test2?.weight, dryWeight, totalTare) : '';
      const moisture3 = tests.length > 3 ? this.calculateMC(test3?.weight, dryWeight, totalTare) : '';

      row.values = [
        item.inHouseId === 0 ? '' : item.inHouseId,
        item.sampleId === 0 ? '' : item.sampleId,
        formattedCastDate === 0 ? '' : formattedCastDate,
        item.sampleType === 0 ? '' : (item.sampleType ?? ''),
        item.mixDesignCode === 0 ? '' : (item.mixDesignCode ?? ''),
        item.tare === 0 ? '' : (item.tare ?? ''),
        item.mould=== 0 ? '' : (item.mould ?? ''),
        item.sampleDiameter === 0 ? '' : (item.sampleDiameter ?? ''),
        item.sampleHeight === 0 ? '' : (item.sampleHeight ?? ''),

        // Test 1 (first)
        test1?.weight === 0 ? '' : (test1?.weight ?? ''),
        test1?.tr === 0 ? '' : (test1?.tr ?? ''),
        moisture1,

        // Test 2 (only if 3+ tests exist)
        test2?.weight === 0 ? '' : (test2?.weight ?? ''),
        test2?.tr === 0 ? '' : (test2?.tr ?? ''),
        moisture2,

        // Test 3 (only if 4+ tests exist)
        test3?.weight === 0 ? '' : (test3?.weight ?? ''),
        test3?.tr === 0 ? '' : (test3?.tr ?? ''),
        moisture3,

        // Test Dry Test ALWAYS last
        testDryTest?.weight === 0 ? '' : (testDryTest?.weight ?? ''),
        testDryTest?.tr === 0 ? '' : (testDryTest?.tr ?? ''),

        this.calculateDensity(dryWeight, item.volume) ?? '',
        ''
      ];

      const baseBorder: Partial<ExcelJS.Borders> = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' },
        bottom: { style: 'thin' }
      };

      const mediumBottomBorder: Partial<ExcelJS.Borders> = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' },
        bottom: { style: 'medium' }
      };

      row.eachCell(cell => {
        cell.alignment = {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true
        };

        cell.border = { ...baseBorder };
        if (isLastRowOfSample) {
          cell.border = { ...mediumBottomBorder };
        }
      });

      currentRow++;
    }

    // Merge vertical cast date, sample type, and mix ID cells for consecutive rows with the same preCastSampleId
    let mergeStartRow = startRow + 2;
    for (let i = 1; i <= worksheets.length; i++) {
      const current = worksheets[i];
      const previous = worksheets[i - 1];
      const currentRowIndex = startRow + 2 + i;

      const isSameSampleGroup = current && previous && current.preCastSampleId === previous.preCastSampleId;

      if (!isSameSampleGroup) {
        const mergeEndRow = currentRowIndex - 1;
        if (mergeEndRow > mergeStartRow) {
          sheet.mergeCells(`B${mergeStartRow}:B${mergeEndRow}`);
          sheet.mergeCells(`C${mergeStartRow}:C${mergeEndRow}`);
          sheet.mergeCells(`D${mergeStartRow}:D${mergeEndRow}`);
          sheet.mergeCells(`E${mergeStartRow}:E${mergeEndRow}`);
        }
        mergeStartRow = currentRowIndex;
      }
    }

    let borderStart = startRow + 2;
    for (let i = 1; i <= worksheets.length; i++) {

      const current = worksheets[i];
      const previous = worksheets[i - 1];

      const isSame =
        current &&
        current.preCastSampleId === previous.preCastSampleId;

      if (!isSame) {

        const borderEnd = startRow + 1 + i;
        [2, 3, 4, 5, 21].forEach(col => {

          const cell = sheet.getCell(borderEnd, col);

          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
            bottom: { style: 'medium' }
          };
        });

        borderStart = borderEnd + 1;
      }
    }

    // ===== HEADER BORDER STYLE =====
    for (let row = 1; row <= 7; row++) {
      for (let col = 1; col <= 22; col++) {
        const cell = sheet.getCell(row, col);
        cell.alignment = {
          horizontal: 'left',
          vertical: 'middle',
          wrapText: true
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      }
    }
    sheet.getCell('S1').alignment = { horizontal: 'center', vertical: 'middle' };
    sheet.getCell('S6').alignment = { horizontal: 'center', vertical: 'middle' };

    // EXPORT
    const buffer = await workbook.xlsx.writeBuffer();
    const fileNameParts = [
      worksheetRecords.company.name,
      worksheetRecords.project.projectName,
      worksheetRecords.project.projectNumber,
      DateTimeUtils.getLocalDateTimeFromUTCDate(worksheetRecords.project.sampleReceivedDate, 'MM/dd/yy'),
    ]
    .filter(v => typeof v === 'string' && v.trim().length > 0)
    .map(v => this.sanitizeFileName(v));

    const fileName = fileNameParts.join('-');
    saveAs(
      new Blob([buffer]),
      `${fileName}.xlsx`
    );
  }

  sanitizeFileName(value: string): string {
    return value.replace(/[\/\\:*?"<>|$%]/g, '').replace(/\s+/g, ' ').trim().replace(/\.+$/, '');
  }

  private calculateMC(weight: any, dryWeight: number, totalTare: number): any {
    if (!dryWeight || !weight) return '';
    const wet = Number(weight ?? 0) - totalTare;

    if (!wet || wet <= 0) { return ''; }
    const m = ((wet - dryWeight) / dryWeight) * 100;
    return Number(m.toFixed(2));
  }

  calculateDensity(dryWeight: number, volume: number): any {
    if (!dryWeight || !volume) return '';
    const dryMassG = Number(dryWeight ?? 0);
    const volumeCm3 = Number(volume ?? 0);

    if (!dryMassG || !volumeCm3) { return ''; }


    const massLb = dryMassG / 453.592;
    const volumeFt3 = volumeCm3 / 28316.8466;
    const densityPcf = massLb / volumeFt3;
    return Number(densityPcf.toFixed(2));
  }

  applyBorderToRange(
    sheet: ExcelJS.Worksheet,
    startRow: number,
    endRow: number,
    colIndex: number,
    border: Partial<ExcelJS.Borders>
  ) {
    for (let r = startRow; r <= endRow; r++) {
      const cell = sheet.getRow(r).getCell(colIndex);
      cell.border = border;
    }
  }
}